<template>
  <div class="bbe-color-palette" v-click-outside="close">
    <div class="bbe-color-palette__item"
         v-for="(color, index) in colorPalette"
         @click="setColor(color)"
         :class="{
           'bbe-color-palette__item_active': checkedColor(color),
           'bbe-color-palette__item_first': index < 16
         }"
         :style="{backgroundColor: color}"
         :key="color"
         :value="color"/>
  </div>
</template>

<script>
import colorPalette from '@/constants/toolbarEditorOptions/colorPalette'

export default {
  name: 'ColorPalette',
  props: ['activeColor'],
  data () {
    return {
      colorPalette: colorPalette
    }
  },
  methods: {
    checkedColor (color) {
      let hex
      try {
        hex = this.rgbToHex(this.activeColor.match(/\d+/gmi))
      } catch (e) {
        hex = this.activeColor
      }
      hex = hex || this.activeColor
      return color === hex
    },
    rgbToHex (rgb) {
      if (!rgb || !Array.isArray(rgb)) return
      const fullHex = []
      rgb.forEach(color => {
        let hex = Number(color).toString(16)
        if (hex.length < 2) {
          hex = '0' + hex
        }
        fullHex.push(hex)
      })
      return '#' + fullHex.join('')
    },
    setColor (color) {
      this.$emit('set', color)
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbe-color-palette {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    grid-gap: 1px;
    z-index: 99;

    &__item {
      width: 18px;
      height: 18px;
      border: 1px solid transparent;
      transition: .1s;

      &_active {
        border: 1px solid;
      }

      &:hover {
        border-color: $color-tundora;
      }

      &_first {
        margin-bottom: 6px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/TextEditor/ColorPalette/ColorPalette.vue